import React from 'react';

const AboutSection: React.FC = () => {
  return (
    <section className="py-20 bg-gray-50 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-text mb-6">
            About Emerik
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto"></div>
        </div>
        
        <div className="bg-white rounded-2xl shadow-lg p-8 sm:p-12">
          <h3 className="text-2xl font-bold text-text mb-6 text-center">
            What We Do
          </h3>
          
          <div className="max-w-3xl mx-auto">
            <p className="text-lg text-text/80 leading-relaxed text-center mb-8">
              Emerik is a tool designed for personal trainers with the aim of helping them in managing day to day business, 
              optimizing operations and assuring exceptional client experience.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left">
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary rounded-full mt-3 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold text-text mb-1">All-in-One CRM Solution</h4>
                    <p className="text-text/70 text-sm">Streamline client management, progress tracking, and business operations in one platform.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary rounded-full mt-3 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold text-text mb-1">Business Optimization</h4>
                    <p className="text-text/70 text-sm">Automate routine tasks and focus on what matters most - your clients' success.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary rounded-full mt-3 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold text-text mb-1">Exceptional Client Experience</h4>
                    <p className="text-text/70 text-sm">Deliver personalized service through better communication and progress tracking.</p>
                  </div>
                </div>
              </div>
              
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary rounded-full mt-3 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold text-text mb-1">Comprehensive Features</h4>
                    <p className="text-text/70 text-sm">From nutrition planning to financial management, we cover every aspect of your business.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary rounded-full mt-3 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold text-text mb-1">Focus on Growth</h4>
                    <p className="text-text/70 text-sm">Spend less time on paperwork and more time transforming lives through fitness.</p>
                  </div>
                </div>
                
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-primary rounded-full mt-3 flex-shrink-0"></div>
                  <div>
                    <h4 className="font-semibold text-text mb-1">Built for Trainers</h4>
                    <p className="text-text/70 text-sm">Designed specifically for personal trainers' unique needs and workflow.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
